import { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useApi } from "../../api";

export default function AdminDashboard() {
  const { get, post, put, delete: remove } = useApi();
  const [institutions, setInstitutions] = useState([]);

  useEffect(() => {
    fetchInstitutions();
  });

  const fetchInstitutions = async () => {
    try {
      const data = await get("/institutions");
      setInstitutions(data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleAddUser = async () => {
    try {
      await post("/institutions", { name: "New User", role: "proctor" });
      fetchInstitutions();
    } catch (err) { console.error(err); }
  };

  const handleUpdateUser = async (id) => {
    try {
      await put(`/institutions/${id}`, { name: "Updated Name" });
      fetchInstitutions();
    } catch (err) { console.error(err); }
  };

  const handleDeleteUser = async (id) => {
    try {
      await remove(`/institutions/${id}`);
      fetchInstitutions();
    } catch (err) { console.error(err); }
  };

  return (
    <Box>
      <Typography variant="h4">Admin Dashboard</Typography>
      {institutions.map((user) => (
        <Box key={user.id} sx={{ mt: 1 }}>
          {user.name} - {user.role}
          <Button size="small" onClick={() => handleUpdateUser(user.id)}>Update</Button>
          <Button size="small" color="error" onClick={() => handleDeleteUser(user.id)}>Delete</Button>
        </Box>
      ))}
      <Button variant="contained" sx={{ mt: 2 }} onClick={handleAddUser}>Add User</Button>
      <Button variant="outlined" sx={{ mt: 2 }} onClick={fetchInstitutions}>Refetch</Button>
    </Box>
  );
}
